import _ from 'lodash';

import { edataQueryAsync } from 'helpers/graphql';
import { fetchSourceAreaSuccess } from './actions';

export const fetchSourceArea = (data) => {
  
  const query = `query(
    $subjectId: String
    $mediaType: [MediaTypeEnum]
    $from: [String]
    ) {
      distribution (
        mediaType: $mediaType
        subjectId: $subjectId
        from: $from
        field: in
      ) {
        key
      }
    }
  `
  return edataQueryAsync(query, data)
  .then((body) => {
    const keys = _.map(body.data.distribution, 'key');
    const from = data.from;
    return fetchSourceAreaSuccess({
      [from]: keys
    });
  })
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/sourceArea/tasks.js
 **/